module.exports = require('./helpers/bundle-url').getBundleURL('iGguq') + "logo.c51670a8.svg";